class PlatformEmbedded {
  constructor () {
    this._updatePageHeight = this._updatePageHeight.bind(this)
    this._begin = this._begin.bind(this)
    this.lastContentHeight = 0

    this._bindEvents()
  }

  _bindEvents () {
    // Deferred, after the module script: parsing is done (readyState
    // 'interactive') and render() has been called, so this posts
    // buyapowa:loaded straight away. Waiting for DOMContentLoaded only while
    // still loading means it can't miss the event however it's loaded.
    if (document.readyState !== 'loading') {
      this._begin()
    } else {
      document.addEventListener('DOMContentLoaded', this._begin, false)
    }
  }

  _updatePageHeight () {
    const contentHeight = document.querySelector('#bp_platform_div').offsetHeight - 10

    if (this.lastContentHeight !== contentHeight) {
      window.parent.postMessage(`buyapowa:height:${contentHeight}`, '*')
      this.lastContentHeight = contentHeight
    }

    setTimeout(this._updatePageHeight, 300)
  }

  _begin () {
    window.parent.postMessage('buyapowa:loaded', '*')
    this._updatePageHeight()
  }
}

new PlatformEmbedded() // eslint-disable-line no-new
